export const showMobileLoyaltyProgram = (state) =>
  state.showMobileLoyaltyProgram || false

export const lnsHistory = (state) => state.history || []
